export default __webpack_public_path__ + "static/media/banner34Auburn.c2a3d031.png";